export const followersListLimit = 15;

export const followingListLimit = 20;

export const blockListLimit = 12;

export const subscriptionsLimit = 3;

export const initialOffset = 0;
